export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      FunctionInfo: {
        FunctionId: 2,
        FunctionName: '御用聞き機能',
        DeliveryType: 'ordertake'
      }
    }
  }
}